<!--
 * @Author: czj
 * @Date: 2025-04-29 10:40:33
 * @Description: 
 * @FilePath: \sanshu-report-new\src\components\ContentCom\comps\PdbeCom.vue
-->
<template>
  <div ref="molstarContainer">
    <div style="margin-bottom: 15px;width: 200px;">
      <el-select v-model="selected_val" placeholder="请选择" @change="handleChange">
        <el-option v-for="(item, index) in pdb_list" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div id="myViewer" ref="molstarViewer"></div>
  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  import PubSub from 'pubsub-js';
  import { transformData } from '@/utils/tool.js';

  const emit = defineEmits([]);
  const props = defineProps(['data', 'task_result']);

  const base_url = process.env.VUE_APP_BASE_API;
  const molstarContainer = ref(null);
  const molstarViewer = ref(null);
  const isVisible = ref(false);//是否进入视口
  const raw_data = ref(null);// 原始数据
  const pdb_list = ref([]);// 所有pdb列表
  const selected_val = ref(null);// 选择的pdb编号
  const node_data_token = ref(null);// 节点数据token

  // let viewerInstance = null;// molstar实例
  const observer = new IntersectionObserver(([entry]) => { // 监听元素是否进入视口
    if (entry.isIntersecting) {
      isVisible.value = true;
      loadPdb(selected_val.value);
      observer.disconnect();// 只触发一次，避免重复加载
    }
  }, { threshold: 0.1 });// 只要 10% 进入视口，就触发

  const loadPdb = function (path) {
    if (!isVisible.value) {
      console.warn('未进入视图窗口');
      return;
    };
    const viewerInstance = new PDBeMolstarPlugin();
    if (typeof path !== 'string') {  // 处理 path 类型为对象或其他非字符串情况
      try {
        // 尝试提取字符串路径（假设传入了类似 { url: '/some/path.pdb' }）
        if (typeof path?.url === 'string') {
          path = path.url;
        } else {
          console.error('[loadPdb] 非法的路径类型，应为字符串或包含 `url` 字段的对象:', path);
          return;
        }
      } catch (e) {
        console.error('[loadPdb] 无法解析路径:', path, e);
        return;
      }
    };
    const match = path.match(/\.([a-zA-Z0-9]+)(\?.*)?$/);//提取文件后缀
    const file_type = match ? match[1].toLowerCase() : null;//文件后缀
    const supportedFormats = ['pdb', 'cif', 'bcif', 'sdf', 'mol'];// 目前支持的格式
    if (!file_type || !supportedFormats.includes(file_type)) {
      console.error(`[loadPdb] 不支持的文件类型: ${file_type}，支持的格式有: ${supportedFormats.join(', ')}`);
      return;
    };
    const file_path = base_url + path; // 拼接完整路径
    const isBinary = file_type === 'bcif'; // 是否为二进制格式
    const options = { // molstar 配置项
      customData: {
        url: file_path,
        format: file_type,
        isBinary,
      },
      hideControls: true,
      landscape: true,
    };
    console.log(`[loadPdb] 正在加载: ${file_path} (格式: ${file_type}, 二进制: ${isBinary})`);
    viewerInstance.render(molstarViewer.value, options);
  };

  const handleChange = function (val) { //选择切换
    console.log('val', val);
    loadPdb(val);
  };

  // 使用 watch 监听 props 的字段变化
  watch(() => props.task_result, (newData, oldData) => {
    let title = props.data.title;
    let node_result = newData[title];
    if (node_result) {
      raw_data.value.process_report[0].default_val = node_result.data;
      pdb_list.value = transformData(node_result.data);
      selected_val.value = pdb_list.value[0].value;
      if (isVisible.value) loadPdb(selected_val.value);// 进入视口时加载pdb
    }
  });
  //组件即将挂载
  onBeforeMount(() => {
    raw_data.value = props.data;
  });
  //组件已经挂载
  onMounted(() => {
    observer.observe(molstarContainer.value);// 监听元素进入视口
    node_data_token.value = PubSub.subscribe(props.data.title, function (msg, data) {
      console.log('当前节点订阅到数据', data);
      raw_data.value.process_report[0].default_val = data.result.data;
      pdb_list.value = transformData(data.result.data);
      selected_val.value = pdb_list.value[0].value;
      if (isVisible.value) loadPdb(selected_val.value);// 进入视口时加载pdb
    });
  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
    if (observer) observer.disconnect();//停止监听
    if (node_data_token.value) PubSub.unsubscribe(node_data_token.value);
  });
  //组件已经卸载
  onUnmounted(() => {
  });
</script>
<style scoped>
  #myViewer {
    width: 100%;
    height: 600px;
    position: relative;
  }
</style>